import { AWFAction } from '@ansys-internal/awf-angular/core';
import {
  CompareJobsExecuteEnum,
  CompareJobsInput,
  CompareJobsOutput,
  CompareJobsState,
} from '../state/lib/compare-jobs.state';
import { State } from '@ansys-internal/awf-angular/store';

/**
 * Reducer for CompareJobsState
 */
@AWFAction()
export class CompareJobsAction {
  constructor(private state: State) {}

  async execute(input: CompareJobsInput): Promise<CompareJobsOutput> {
    const current = this.state.value(CompareJobsState);

    let updated: CompareJobsInput;

    switch (input.type) {
      case CompareJobsExecuteEnum.SET_JOBS:
        updated = {
          type: input.type,
          jobs: input.jobs,
        };
        this.state.set(CompareJobsState, {
          ...current,
          jobs: input.jobs,
        });

        return updated;

      case CompareJobsExecuteEnum.ADD_RESULT_TO_COMPARE:
        const added = (current.resultsToCompare ?? []).concat(
          input.resultsToCompare ?? []
        );
        this.state.set(CompareJobsState, {
          ...current,
          resultsToCompare: added,
        });
        return input;

      case CompareJobsExecuteEnum.GET_RESULT_TO_COMPARE:
        const found = this.state
          .value(CompareJobsState)
          .resultsToCompare?.find((result) => result.id === input.resultId);

        return {
          type: CompareJobsExecuteEnum.GET_RESULT_TO_COMPARE,
          result: found,
        };

      case CompareJobsExecuteEnum.REMOVE_RESULT_FROM_COMPARE:
        const updatedResults = (current.resultsToCompare ?? []).filter((r) => {
          return r.id !== input.resultId;
        });

        this.state.set(CompareJobsState, {
          ...current,
          resultsToCompare: updatedResults,
        });

        return {
          type: CompareJobsExecuteEnum.REMOVE_RESULT_FROM_COMPARE,
          resultsToCompare: updatedResults,
        };

      case CompareJobsExecuteEnum.CLEAR_RESULTS_FROM_COMPARE:
        this.state.set(CompareJobsState, {
          ...current,
          resultsToCompare: null,
          jobs: null,
        });
        return input;
    }
  }
}
